<script lang='ts'>
  import EnableSwitch from './Editor/EnableSwitch.svelte';
  import type { Storefront } from 'app/javascript/shared/javascripts/types/Storefront';
  import { tick } from 'svelte';

  export let title : string;
  export let activeSection : string;
  export let domId : string;
  export let enableProp : string = undefined;
  export let callbacks: any;
  export let storefront : Storefront;

  async function toggleActive() {
    active ? activeSection = null : activeSection = title;
    if (active) { return; }
    await tick();
    callbacks.scrollToElementInIframe(domId);
    callbacks.setActiveSection(activeSection)
  }

  $: active = activeSection == title;
</script>

{#if active}
  <dt on:click={toggleActive}
    id="{'edit_'+domId}" class="fizz-is-open {(domId==='collections'||domId==='featured_items'||domId=='featured_product_featured') ? 'fizz-stack-16':''}">{title}
    {#if enableProp}
      <EnableSwitch bind:val={storefront[enableProp]}
        changeCB={() => callbacks.update(storefront)}
        {domId}></EnableSwitch>
    {/if}
  </dt>

  {#if domId === 'collections' || domId === 'featured_items' || domId==='featured_product_featured'}
    <slot></slot>
  {:else}
    <dd id="{'inner_edit_'+domId}">
      <slot></slot>
    </dd>
  {/if}
{:else if !activeSection}
  <dt on:click={toggleActive}
    id="{'edit_'+domId}">{title}</dt>
{/if}
